import { Loader2, PlusCircle } from "lucide-react";

interface PaginationLoaderProps {
  hasNext: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

export default function PaginationLoader({
  hasNext,
  loading,
  onLoadMore,
}: PaginationLoaderProps) {

  if (!hasNext) return null;

  return (
    <div className="flex justify-center pt-4">
      <button
        onClick={onLoadMore}
        disabled={loading}
        className="flex items-center gap-2 px-4 py-2 border rounded-lg text-sm font-medium
                   text-primary-500 border-primary-500 hover:bg-primary-500/10 disabled:opacity-50
                   transition-all"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Loading...
          </>
        ) : (
          <>
            <PlusCircle className="w-4 h-4" />
            Load More
          </>
        )}
      </button>
    </div>
  );
}
